<template>
  <div class="mediablock">
    <FancyboxBlock
      v-if="mediaData.file_type == 'image'"
      :key="`image-${mediaData.id}`"
    >
      <a data-fancybox="gallery" :href="mediaData.url">
        <img :src="mediaData.url" />
      </a>
    </FancyboxBlock>
    <AudioBlock
      v-else-if="mediaData.file_type == 'audio'"
      :key="`audio-${mediaData.id}`"
      :mediaData="mediaData"
    />
    <VideoBlock
      v-cloak
      v-else-if="mediaData.file_type == 'video'"
      :key="`video-${mediaData.id}`"
      :mediaData="mediaData"
    />
    <div v-else class="download">
      <a :id="mediaData.id" :href="mediaData.url">
        <DownloadIcon class="file-icon" />
        <span>
          {{ mediaData.title }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import FancyboxBlock from '@/components/blocks/fancybox/FancyboxBlock.vue';
import VideoBlock from '@/components/blocks/media/VideoBlock.vue';
import AudioBlock from '@/components/blocks/media/AudioBlock.vue';
import DownloadIcon from '@/components/icons/DownloadIcon.vue';

export default {
  name: 'MediaBlock',
  components: {
    FancyboxBlock,
    DownloadIcon,
    VideoBlock,
    AudioBlock,
  },
  props: {
    media: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mediaData: false,
    };
  },
  mounted() {
    this.mediaData = this.media;
  },
  watch: {
    media() {
      this.mediaData = this.media;
    },
  },
};
</script>

<style lang="scss" scoped>
.mediablock {
  width: 100%;
  height: 220px;
  border-radius: 8px;
  overflow: hidden;
  background: linear-gradient(
    177.33deg,
    #004996 5.49%,
    #0e58a5 47.68%,
    #4898ec 109.01%
  );
  img {
    display: block;
    width: 100%;
    height: 220px;
    object-fit: cover;
  }
  .download {
    display: block;
    width: 100%;
    height: 220px;
    a {
      position: relative;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      width: 100%;
      height: 220px;
      padding: 10px;
      span {
        color: var(--color-white);
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%;
      }
    }
  }
  svg.file-icon {
    position: absolute;
    left: 50%;
    top: 20px;
    transform: translateX(-50%);
    width: 100px;
    height: 100px;
    min-width: 100px;
    min-height: 100px;
    color: var(--color-white);
  }
}
</style>
